<template>
    <div class="px-2">
        <h3 class="title py-3">
            My Bids
        </h3>

        <div
            class="table-wrapper overflow-auto"
            @scroll="onScroll">
            <v-simple-table
                fixed-header>
                <template v-slot:default>
                    <thead class="mb-3">
                        <tr class="pb-2 black">
                            <th />

                            <th>
                                Address
                            </th>

                            <th>
                                Sale Type
                            </th>

                            <th>
                                My Bids
                            </th>

                            <th>
                                Status
                            </th>

                            <th>
                                Time Left
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <personal-info-my-bids-row
                            v-for="participation in participations"
                            :key="participation.id"
                            :participation="participation"
                            @current-bid-id-update="updateCurrentBidId($event, participation)"
                            @end-date-update="updateEndDate($event, participation)" />
                    </tbody>
                </template>
            </v-simple-table>
            <v-row
                v-if="loading"
                style="width: 100%">
                <v-col
                    cols="12"
                    class="text-center">
                    <v-progress-circular
                        size="48"
                        indeterminate />
                </v-col>
            </v-row>
            <p
                v-if="!loading && !participations.length"
                class="pa-6">
                There are no bids to show.
            </p>
        </div>
    </div>
</template>

<script>
import PersonalInfoMyBidsRow from '@/components/PersonalInfo/PersonalInfoMyBidsRow';
import participations from '@/api/participations';
import subscriptions from '@/api/subscriptions';

export default {
    name: 'PersonalInfoMyBids',

    components: { PersonalInfoMyBidsRow },

    data() {
        return {
            participations: [],
            loading: true,
            bidsPerPage: 10,
            nextToken: '',
            lastPage: false,
        };
    },

    created() {
        this.fetchParticipationsList();

        const userId = JSON.parse(localStorage.getItem('currentUser')).sub;
        const createParticipationSub = subscriptions.onCreateParticipationOwner(userId).subscribe((participation) => {
            const index = this.participations.findIndex((p) => p.id === participation.id);
            if (index === -1) {
                this.participations.unshift(participation);
            } else {
                this.participations[index].bid = participation.bid;
            }
        });

        this.$once('hook:beforeDestroy', () => {
            createParticipationSub.unsubscribe();
        });
    },

    methods: {
        onScroll(e) {
            if (this.loading || this.lastPage) return;
            const isScrollOnBottom = e.target.clientHeight + e.target.scrollTop === e.target.scrollHeight;
            if (isScrollOnBottom) this.fetchParticipationsList();
        },
        async fetchParticipationsList() {
            this.loading = true;
            try {
                const { data } = await participations.fetchParticipationsList(this.bidsPerPage, this.nextToken);
                if (data.listMyParticipations) {
                    this.nextToken = data.listMyParticipations.nextToken;
                    data.listMyParticipations.data.forEach((participation) => {
                        if (!this.participations.some((p) => p.id === participation.id)) {
                            this.participations.push(participation);
                        }
                    });
                    this.$forceUpdate();
                    if (!data.listMyParticipations.nextToken) this.lastPage = true;
                } else {
                    this.lastPage = true;
                }
            } catch (error) {
                this.$store.commit('snackbar', {
                    text: (error.errors && error.errors[0].message) || 'Something went wrong',
                    color: 'error',
                    isOpened: true,
                });
            } finally {
                this.loading = false;
            }
        },
        updateCurrentBidId(newBidId, participation) {
            participation.sale[participation.sale.kind].currentBidID = newBidId;
        },
        updateEndDate(endDate, participation) {
            participation.sale[participation.sale.kind].endDate = endDate;
        },
    },
};
</script>

<style scoped lang="scss">
.table-wrapper {
    max-height: 400px;
    th {
        color: #fff !important;
        background-color: #000 !important;
    }
}
</style>